/* ============================================================
   LP 5 Razões para Escolher Guday — JS
   IIFE idempotente, escopado na raiz .lp-5razoes-wrap.
   - Smooth-scroll dos CTAs → bloco produto (#lp-produto, em outra section)
   - Bloco produto (portado da lp-guday-creatina, prefixo .lp-pa-):
     hero carousel, bundle ladder, recalc, add-to-cart, FAQ, lab modal
   _lp_source = 'lp-5-razoes' (atribuição de receita)
   ============================================================ */
(function(){
  function init(root){
    if (!root || root.dataset.lpInit === '1') return;
    root.dataset.lpInit = '1';

    /* ============== SMOOTH-SCROLL CTA → bloco produto (#lp-produto) ============== */
    /* O alvo (#lp-produto) vive em OUTRA section (lp-5-razoes-produto), então
       busca no document inteiro, não só no root desta instância. */
    root.querySelectorAll('[data-lp-scroll-produto]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        var target = document.getElementById('lp-produto');
        if (target){ e.preventDefault(); target.scrollIntoView({ behavior:'smooth', block:'start' }); }
      });
    });

    /* ============== HERO CAROUSEL (bloco produto) ============== */
    (function(){
      var track = root.querySelector('.lp-pa-hero-track');
      if (!track) return;
      var slides = track.querySelectorAll('.lp-pa-hero-slide');
      var dotsWrap = root.querySelector('.lp-pa-hero-dots');
      var thumbs = root.querySelectorAll('.lp-pa-hero-thumb');
      if (!dotsWrap || slides.length === 0) return;

      dotsWrap.innerHTML = '';
      slides.forEach(function(_, i){
        var b = document.createElement('button');
        b.type = 'button';
        if (i === 0) b.classList.add('lp-active');
        b.addEventListener('click', function(){ go(i); });
        dotsWrap.appendChild(b);
      });
      var dots = dotsWrap.querySelectorAll('button');
      var cur = 0;
      function sync(){
        dots.forEach(function(d, k){ d.classList.toggle('lp-active', k === cur); });
        thumbs.forEach(function(t, k){ t.classList.toggle('lp-active', k === cur); });
      }
      function go(i){
        cur = (i + slides.length) % slides.length;
        track.scrollTo({ left: cur * track.clientWidth, behavior:'smooth' });
        sync();
      }
      var prev = root.querySelector('.lp-pa-hero-arrow.lp-prev');
      var next = root.querySelector('.lp-pa-hero-arrow.lp-next');
      if (prev) prev.addEventListener('click', function(){ go(cur - 1); });
      if (next) next.addEventListener('click', function(){ go(cur + 1); });
      var scrollTimer = null;
      track.addEventListener('scroll', function(){
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function(){
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== cur){ cur = i; sync(); }
        }, 60);
      });
      thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(parseInt(t.dataset.idx, 10) || 0); }); });
    })();

    /* ============== BUNDLE PICKER (ladder + add-to-cart) ============== */
    (function(){
      var items = root.querySelectorAll('.lp-pa-item');
      var cta = root.querySelector('.lp-pa-buy');
      if (items.length === 0 || !cta) return;

      function getQ(it){ return parseInt(it.querySelector('.lp-qty').textContent, 10) || 0; }
      function setQ(it, n){ it.querySelector('.lp-qty').textContent = Math.max(0, n); }
      function fmt(n){ return 'R$ ' + n.toFixed(2).replace('.', ','); }
      function discountFor(q){ if (q >= 3) return 0.15; if (q === 2) return 0.10; return 0; }

      // Clickable ladder steps
      root.querySelectorAll('.lp-pa-ladder-step').forEach(function(step){
        step.addEventListener('click', function(e){
          e.preventDefault();
          var target = parseInt(step.dataset.step, 10);
          var arr = Array.from(items);
          var totalQty = arr.reduce(function(s, it){ return s + getQ(it); }, 0);
          if (target > totalQty){
            var need = target - totalQty;
            while (need > 0){
              var best = arr[0], bestQ = getQ(arr[0]);
              arr.forEach(function(it){ var q = getQ(it); if (q > bestQ){ bestQ = q; best = it; } });
              setQ(best, getQ(best) + 1);
              need--;
            }
          } else if (target < totalQty){
            var excess = totalQty - target;
            while (excess > 0){
              var b2 = null, bq = 0;
              arr.forEach(function(it){ var q = getQ(it); if (q > bq){ bq = q; b2 = it; } });
              if (!b2 || bq <= 0) break;
              setQ(b2, bq - 1);
              excess--;
            }
          }
          recalc();
        });
      });

      function recalc(){
        var totalQty = 0, subtotal = 0;
        items.forEach(function(it){
          var q = getQ(it);
          var price = parseFloat(it.dataset.price) || 0;
          totalQty += q; subtotal += q * price;
          it.classList.toggle('lp-has-qty', q > 0);
        });

        var reached = Math.max(0, Math.min(3, totalQty));
        var activeStep = reached === 0 ? 1 : reached;
        root.querySelectorAll('.lp-pa-ladder-step').forEach(function(step){
          var s = parseInt(step.dataset.step, 10);
          step.classList.remove('lp-active', 'lp-done');
          if (s <= reached) step.classList.add('lp-done');
          if (s === activeStep) step.classList.add('lp-active');
        });

        var progress = root.querySelector('.lp-pa-ladder-progress');
        if (progress){
          var pct = 0;
          if (reached === 2) pct = 50; else if (reached >= 3) pct = 100;
          progress.style.width = pct + '%';
        }

        var msg = root.querySelector('.lp-pa-ladder-msg');
        var msgText = root.querySelector('.lp-pa-ladder-msg-text');
        if (msg && msgText){
          msg.classList.remove('lp-done');
          if (totalQty === 0) msgText.innerHTML = '🎁 Adicione <b>+1 pote</b> e destrave <b>frete grátis</b>';
          else if (totalQty === 1) msgText.innerHTML = '🎁 Adicione <b>+1 pote</b> e destrave <b>frete grátis + 10% OFF</b>';
          else if (totalQty === 2) msgText.innerHTML = '🎁 Adicione <b>+1 pote</b> e destrave <b>15% OFF</b> + frete grátis';
          else { msg.classList.add('lp-done'); msgText.innerHTML = '✅ Você destravou o melhor desconto: <b>15% OFF + frete grátis</b>'; }
        }

        var lcta = root.querySelector('.lp-pa-ladder-cta');
        var lctaText = root.querySelector('.lp-pa-ladder-cta-text');
        if (lcta && lctaText){
          if (totalQty >= 3) lcta.classList.add('lp-hide');
          else {
            lcta.classList.remove('lp-hide');
            if (totalQty === 0) lctaText.textContent = 'Adicione potes abaixo para destravar os descontos';
            else if (totalQty === 1) lctaText.innerHTML = 'Adicione +1 pote para destravar <b>10% OFF + frete grátis</b>';
            else lctaText.innerHTML = 'Adicione +1 pote para destravar a <b>melhor oferta</b>';
          }
        }

        var disc = discountFor(totalQty);
        var final = subtotal * (1 - disc);
        var sum = root.querySelector('.lp-pa-summary');
        var qtyEl = root.querySelector('.lp-pa-sum-qty');
        var nowEl = root.querySelector('.lp-pa-sum-now');
        var oldEl = root.querySelector('.lp-pa-sum-old');
        var offEl = root.querySelector('.lp-pa-sum-off');
        var metaEl = root.querySelector('.lp-pa-sum-meta');
        var perEl = root.querySelector('.lp-pa-sum-per');
        var saveEl = root.querySelector('.lp-pa-sum-save');
        if (!sum || !qtyEl || !nowEl || !oldEl || !offEl) return;

        if (totalQty === 0){
          sum.classList.remove('lp-is-active', 'lp-is-discounted');
          qtyEl.textContent = 'Selecione os sabores acima';
          nowEl.textContent = 'R$ 0,00';
          oldEl.classList.add('lp-empty');
          if (metaEl) metaEl.classList.add('lp-empty');
          cta.textContent = 'ESCOLHA OS SABORES';
          cta.style.opacity = '.65'; cta.style.pointerEvents = 'none';
        } else {
          sum.classList.add('lp-is-active');
          var benefit = totalQty === 1 ? '· sem desconto' : (totalQty === 2 ? '· frete grátis + 10% OFF' : '· frete grátis + 15% OFF 🎉');
          qtyEl.innerHTML = '<b>' + totalQty + (totalQty === 1 ? ' pote' : ' potes') + '</b> ' + benefit;
          nowEl.textContent = fmt(final);
          cta.textContent = 'COMPRAR AGORA';
          cta.style.opacity = '1'; cta.style.pointerEvents = 'auto';
          if (metaEl && perEl){
            metaEl.classList.remove('lp-empty');
            perEl.textContent = fmt(final / totalQty) + ' por pote';
            var savings = subtotal - final;
            if (saveEl) saveEl.textContent = savings > 0 ? ' · você economiza ' + fmt(savings) : '';
          }
          if (disc > 0){
            sum.classList.add('lp-is-discounted');
            oldEl.textContent = fmt(subtotal); oldEl.classList.remove('lp-empty');
            offEl.textContent = Math.round(disc * 100) + '% OFF';
          } else { sum.classList.remove('lp-is-discounted'); oldEl.classList.add('lp-empty'); }
        }
      }

      items.forEach(function(item){
        var qtyEl = item.querySelector('.lp-qty');
        if (!qtyEl) return;
        var set = function(n){ qtyEl.textContent = Math.max(0, n); recalc(); };
        var addBtn = item.querySelector('.lp-pa-add');
        var plus = item.querySelector('.lp-plus');
        var minus = item.querySelector('.lp-minus');
        if (addBtn) addBtn.addEventListener('click', function(){ set(1); });
        if (plus) plus.addEventListener('click', function(){ set((+qtyEl.textContent) + 1); });
        if (minus) minus.addEventListener('click', function(){ set((+qtyEl.textContent) - 1); });
      });

      // CTA → /cart/add.js then redirect to checkout
      cta.addEventListener('click', async function(){
        var cartItems = [];
        items.forEach(function(it){
          var qty = parseInt(it.querySelector('.lp-qty').textContent, 10) || 0;
          var variantId = parseInt(it.dataset.variantId, 10);
          if (qty > 0 && variantId){
            cartItems.push({ id: variantId, quantity: qty, properties: { '_lp_source': 'lp-5-razoes' } });
          }
        });
        if (cartItems.length === 0) return;
        cta.classList.add('lp-loading');
        try {
          var res = await fetch('/cart/add.js', {
            method:'POST',
            headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
            body: JSON.stringify({ items: cartItems })
          });
          if (!res.ok){
            var err = await res.json().catch(function(){ return {}; });
            alert(err.description || 'Não foi possível adicionar ao carrinho. Tente novamente.');
            cta.classList.remove('lp-loading');
            return;
          }
          window.location.href = '/checkout';
        } catch (e){
          cta.classList.remove('lp-loading');
          alert('Erro de conexão. Tente novamente.');
        }
      });

      recalc();
    })();

    /* ============== FAQ ACCORDION (bloco produto) ============== */
    root.querySelectorAll('.lp-pa-faq-item').forEach(function(item){
      var q = item.querySelector('.lp-pa-faq-q');
      if (!q) return;
      q.addEventListener('click', function(){
        var wasOpen = item.classList.contains('lp-open');
        root.querySelectorAll('.lp-pa-faq-item.lp-open').forEach(function(o){ o.classList.remove('lp-open'); });
        if (!wasOpen) item.classList.add('lp-open');
      });
    });

    /* ============== LAB MODAL (Eurofins) ============== */
    (function(){
      var trigger = root.querySelector('[data-lab-open]');
      var modal = root.querySelector('.lp-modal');
      if (!trigger || !modal) return;
      var panel = modal.querySelector('.lp-modal__panel');
      var closeEls = modal.querySelectorAll('[data-lab-close]');
      var lastFocus = null;
      function open(){
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.classList.add('lp-modal-open');
        var closeBtn = modal.querySelector('.lp-modal__close');
        if (closeBtn) closeBtn.focus();
        document.addEventListener('keydown', onKey);
      }
      function close(){
        modal.hidden = true;
        document.body.classList.remove('lp-modal-open');
        document.removeEventListener('keydown', onKey);
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }
      function onKey(e){ if (e.key === 'Escape'){ e.preventDefault(); close(); } }
      function onModalClick(e){ if (panel && !panel.contains(e.target)) close(); }
      trigger.addEventListener('click', open);
      closeEls.forEach(function(el){ el.addEventListener('click', close); });
      modal.addEventListener('click', onModalClick);
    })();
  }

  function boot(){ document.querySelectorAll('.lp-5razoes-wrap').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
